var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 65,
    viewBox: "0 0 91 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 26795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5622",
    d: "M72.3431 0.547974H17.486C14.9612 0.547974 12.9146 2.59467 12.9146 5.1194V59.9766C12.9146 62.5013 14.9612 64.548 17.486 64.548H72.3431C74.8679 64.548 76.9146 62.5013 76.9146 59.9766V5.1194C76.9146 2.59467 74.8679 0.547974 72.3431 0.547974Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_158_12953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5623",
    d: "M65.0288 5.11951H3.31452C2.05216 5.11951 1.02881 6.14286 1.02881 7.40522V18.8338C1.02881 20.0962 2.05216 21.1195 3.31452 21.1195H65.0288C66.2912 21.1195 67.3145 20.0962 67.3145 18.8338V7.40522C67.3145 6.14286 66.2912 5.11951 65.0288 5.11951Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617",
    d: "M32.5711 8.77661H20.6854C19.928 8.77661 19.314 9.39062 19.314 10.148C19.314 10.9055 19.928 11.5195 20.6854 11.5195H32.5711C33.3285 11.5195 33.9425 10.9055 33.9425 10.148C33.9425 9.39062 33.3285 8.77661 32.5711 8.77661Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618",
    d: "M40.7997 14.7195H20.6854C19.928 14.7195 19.314 15.3335 19.314 16.0909C19.314 16.8483 19.928 17.4623 20.6854 17.4623H40.7997C41.5571 17.4623 42.1711 16.8483 42.1711 16.0909C42.1711 15.3335 41.5571 14.7195 40.7997 14.7195Z",
    fill: "#EAECF0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5624",
    d: "M13.3718 6.49133H4.68611C3.42374 6.49133 2.40039 7.51468 2.40039 8.77705V17.4628C2.40039 18.7251 3.42374 19.7485 4.68611 19.7485H13.3718C14.6342 19.7485 15.6575 18.7251 15.6575 17.4628V8.77705C15.6575 7.51468 14.6342 6.49133 13.3718 6.49133Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter1_d_158_12953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 25918",
    d: "M22.9717 24.7766H84.686C85.2923 24.7766 85.8736 25.0174 86.3023 25.4461C86.7309 25.8747 86.9718 26.4561 86.9718 27.0623V38.4909C86.9718 39.0971 86.7309 39.6785 86.3023 40.1071C85.8736 40.5358 85.2923 40.7766 84.686 40.7766H22.9717C22.3655 40.7766 21.7842 40.5358 21.3555 40.1071C20.9269 39.6785 20.686 39.0971 20.686 38.4909V27.0623C20.686 26.4561 20.9269 25.8747 21.3555 25.4461C21.7842 25.0174 22.3655 24.7766 22.9717 24.7766V24.7766Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26775_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617_2",
    d: "M52.2283 28.4336H40.3426C39.5852 28.4336 38.9712 29.0476 38.9712 29.805C38.9712 30.5624 39.5852 31.1765 40.3426 31.1765H52.2283C52.9858 31.1765 53.5998 30.5624 53.5998 29.805C53.5998 29.0476 52.9858 28.4336 52.2283 28.4336Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618_2",
    d: "M60.4569 34.3763H40.3426C39.5852 34.3763 38.9712 34.9904 38.9712 35.7478C38.9712 36.5052 39.5852 37.1192 40.3426 37.1192H60.4569C61.2143 37.1192 61.8283 36.5052 61.8283 35.7478C61.8283 34.9904 61.2143 34.3763 60.4569 34.3763Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5624_2",
    d: "M33.029 26.1484H24.3433C23.081 26.1484 22.0576 27.1718 22.0576 28.4342V37.1199C22.0576 38.3822 23.081 39.4056 24.3433 39.4056H33.029C34.2914 39.4056 35.3148 38.3822 35.3148 37.1199V28.4342C35.3148 27.1718 34.2914 26.1484 33.029 26.1484Z",
    fill: "#98A2B3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter2_d_158_12953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 25919",
    d: "M3.31452 44.4337H65.0288C65.635 44.4337 66.2164 44.6745 66.6451 45.1032C67.0737 45.5318 67.3145 46.1132 67.3145 46.7194V58.148C67.3145 58.7542 67.0737 59.3356 66.6451 59.7642C66.2164 60.1929 65.635 60.4337 65.0288 60.4337H3.31452C2.70831 60.4337 2.12693 60.1929 1.69828 59.7642C1.26962 59.3356 1.02881 58.7542 1.02881 58.148V46.7194C1.02881 46.1132 1.26962 45.5318 1.69828 45.1032C2.12693 44.6745 2.70831 44.4337 3.31452 44.4337V44.4337Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26775_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5617_3",
    d: "M32.5711 48.0911H20.6854C19.928 48.0911 19.314 48.7051 19.314 49.4625C19.314 50.2199 19.928 50.8339 20.6854 50.8339H32.5711C33.3285 50.8339 33.9425 50.2199 33.9425 49.4625C33.9425 48.7051 33.3285 48.0911 32.5711 48.0911Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5618_3",
    d: "M40.7997 54.0339H20.6854C19.928 54.0339 19.314 54.6479 19.314 55.4054C19.314 56.1628 19.928 56.7768 20.6854 56.7768H40.7997C41.5571 56.7768 42.1711 56.1628 42.1711 55.4054C42.1711 54.6479 41.5571 54.0339 40.7997 54.0339Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5624_3",
    d: "M13.3718 45.8057H4.68611C3.42374 45.8057 2.40039 46.829 2.40039 48.0914V56.7771C2.40039 58.0395 3.42374 59.0628 4.68611 59.0628H13.3718C14.6342 59.0628 15.6575 58.0395 15.6575 56.7771V48.0914C15.6575 46.829 14.6342 45.8057 13.3718 45.8057Z",
    fill: "#98A2B3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_158_12953",
    x: 0.268252,
    y: 4.35895,
    width: 70.0884,
    height: 19.8028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14083,
    dy: 1.14083
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.950695
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_12953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_12953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_12953",
    x: 19.9255,
    y: 24.0161,
    width: 70.0884,
    height: 19.8028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14083,
    dy: 1.14083
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.950695
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_12953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_12953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_158_12953",
    x: 0.268252,
    y: 43.6732,
    width: 70.0884,
    height: 19.8028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14083,
    dy: 1.14083
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.950695
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_12953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_12953",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapEmptyState);
export default __webpack_public_path__ + "static/media/map-empty-state.0a3b7487f4dad08efb16c2ba6b015358.svg";
export { ForwardRef as ReactComponent };